<template>
  <AbstractCourseCard class="service-course-card" v-bind="$attrs" v-on="$listeners">
    <template #course-badge>
      <ServiceCourseBadge />
    </template>
    <template #course-title>
      <CourseExecutor v-bind="$attrs" />
    </template>
    <template #course-subtitle v-if="$attrs.course.driver">
      <CourseExecutorLabel :name="$attrs.course.driver.name" :phone="$attrs.course.driver.phone" />
    </template>
  </AbstractCourseCard>
</template>

<script>
import CourseExecutorLabel from '@/component/NewCourse/course-executor-label';
import AbstractCourseCard from './abstract-course-card';
import ServiceCourseBadge from './CourseBadge/service-course-badge';
import CourseExecutor from './CourseTitle/course-executor';

export default {
  name: 'ServiceCourseCard',
  inheritAttrs: false,
  components: {
    AbstractCourseCard,
    ServiceCourseBadge,
    CourseExecutorLabel,
    CourseExecutor,
  },
};
</script>

<style lang="scss" scoped>
@use '@/core/style/global.scss' as *;

.service-course-card.theme--light.v-card {
  @include course-card(var(--service-course-card-background-color), var(--service-course-card-border-color));
}
</style>
